import { Box, IconButton } from "@mui/material";

import { useTranslation } from "react-i18next";
import deleteIcon from "../assets/icons/delete.png";

export const ClearNoteButton = ({ action }) => {
	const { t } = useTranslation();

	return (
		<IconButton
			size="small"
			aria-label={t("remove")}
			title={t("remove")}
			onClick={action}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					padding: "2px",
					border: "1px solid rgba(224, 224, 224, 1)",
					background: "#fff",
					borderRadius: "4px",
					cursor: "pointer",
					height: "18px",
					width: "18px",
				}}
			>
				<img
					src={deleteIcon}
					alt="delete"
					style={{
						width: "100%",
						height: "100%",
						objectFit: "contain",
					}}
				/>
			</Box>
		</IconButton>
	);
};
